// @ts-check
import _ from 'lodash';
import Icon from 'components/base/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import { LBButton } from '@linearb/buzz';

const IconToggle = ({
  name,
  color = 'chambray',
  checkedColor = color,
  isChecked,
  tooltipContent,
  onClick
}) => {
  return (
    <Tooltip
      title={tooltipContent || ''}
      interactive
      placement='top-end'
      disableHoverListener={_.isEmpty(tooltipContent)}
    >
      <div>
        <LBButton
          color={isChecked ? checkedColor : color}
          size='icon'
          variant={isChecked ? 'default' : 'ghost'}
          onClick={onClick}
        >
          <Icon
            name={name}
            size='small'
            color={isChecked ? 'white' : undefined}
          />
        </LBButton>
      </div>
    </Tooltip>
  );
};

export default IconToggle;
